// Grid theme constants for ag-grid
// These themes provide consistent styling across the application

export const quartzThemeBase = {
  accentColor: "#087AD1",
  backgroundColor: "#FFFFFF",
  borderColor: "#D7E2E6",
  borderRadius: 2,
  browserColorScheme: "light",
  cellHorizontalPaddingScale: 0.16,
  chromeBackgroundColor: {
    ref: "backgroundColor"
  },
  columnBorder: false,
  fontFamily: {
    googleFont: "Inter"
  },
  fontSize: 13,
  foregroundColor: "#555B62",
  headerBackgroundColor: "#D9D9D9",
  headerFontSize: 13,
  headerFontWeight: 400,
  headerTextColor: "#141414",
  headerVerticalPaddingScale: 1,
  oddRowBackgroundColor: "#0000FF0F",
  rowBorder: true,
  rowVerticalPaddingScale: 0.8,
  sidePanelBorder: true,
  spacing: "2px",
  wrapperBorder: false,
  wrapperBorderRadius: 2
};

export const quartzExcel = {
  // Use the Excel brand green, or pick your own
  accentColor: "#217346",

  // Keep background white
  backgroundColor: "#FFFFFF",

  // Subtle gray border color for grid lines
  borderColor: "#D0D7D0",

  // Keep corners slightly rounded (feel free to set to 0 for sharp corners)
  borderRadius: 2,

  // Force light mode
  browserColorScheme: "light",

  // Slight horizontal padding
  cellHorizontalPaddingScale: 0.5,

  // Inherit chrome background from the base background
  chromeBackgroundColor: {ref: "backgroundColor"},

  // Turn on both row and column borders to mimic Excel grid lines
  rowBorder: true,
  columnBorder: true,

  // Use a standard, easy-to-read font. Inter is fine, or "Arial" as an alternative
  fontFamily: {googleFont: "Inter"},

  // Slightly smaller text (Excel-like)
  fontSize: 12,
  foregroundColor: "#000000",

  // Subtle gray header background with bold black text
  headerBackgroundColor: "#D9D9D9",
  headerFontSize: 12,
  headerFontWeight: 700,
  headerTextColor: "#000000",

  // Slightly smaller header vertical padding
  headerVerticalPaddingScale: 0.5,

  // Banded rows: light gray for odd rows
  oddRowBackgroundColor: "#F3F3F3",

  // Decrease row vertical padding for a tighter table
  rowVerticalPaddingScale: 0.6,

  // Side panel border on
  sidePanelBorder: true,

  // Minimal spacing
  spacing: "2px",

  // Optional outer wrapper styling
  wrapperBorder: true,
  wrapperBorderRadius: 2
};